<template>
  <button
    type="button"
    class="ui-button"
    :class="[`ui-button-${variant}`, `ui-button-${size}`]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'UiButton',
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style scoped>
.ui-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 10px;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}

.ui-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.ui-button-default {
  border-color: hsl(var(--primary));
  background: hsl(var(--primary));
  color: hsl(var(--primary-foreground));
}

.ui-button-default:hover {
  background: hsl(0 0% 82%);
}

.ui-button-secondary {
  border-color: hsl(var(--border));
  background: hsl(var(--secondary));
  color: hsl(var(--foreground));
}

.ui-button-outline {
  border-color: hsl(var(--border));
  background: transparent;
  color: hsl(var(--foreground));
}

.ui-button-ghost {
  border-color: transparent;
  background: transparent;
  color: hsl(var(--muted-foreground));
}

.ui-button-secondary:hover,
.ui-button-outline:hover,
.ui-button-ghost:hover {
  border-color: hsl(0 0% 26%);
  background: hsl(var(--secondary));
  color: hsl(var(--foreground));
}

.ui-button-sm {
  min-height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 0.78rem;
}
</style>
